<template>
  <div>
    <div class="box" v-for="(item,index) in itemList" :key="index">
      <div class="box-header">
        <div class="title">{{item.title}}</div>
      </div>
      <div class="box-content">
        <a-row :gutter="16">
          <a-col :span="12" v-for="(itemChildren,indexChildren) in item.children" :key="indexChildren">
            <div class="link"><router-link :to="itemChildren.path">{{itemChildren.title}}</router-link></div>
          </a-col>
        </a-row>
      </div>
    </div>
    <!--box-->
  </div>
</template>

<script setup>
import {
  DesktopOutlined,
  ProjectOutlined, ProfileOutlined, SolutionOutlined,RetweetOutlined,AuditOutlined,
  DatabaseOutlined,
  ContainerOutlined,FileOutlined,SettingOutlined,
  TeamOutlined,UserSwitchOutlined,
  FileMarkdownOutlined,ControlOutlined,
  RollbackOutlined,
} from '@ant-design/icons-vue';
import {reactive, ref} from "vue";
const itemList = [
  // {
  //   title:"工作台",
  //   path:"/store/task/after/index"
  // },
  {
    title:"文章管理",
    children:[
      {title:"文章分类", path:"/articleCategory/index",},
      {title:"文章列表", path:"/article/index",},
    ]
  },
  {
    title:"产品管理",
    children:[
      {title:"产品分类", path:"/productCategory/index",},
      {title:"产品列表", path:"/product/index",},
    ]
  },
  {
    title:"广告管理",
    children:[
      {title:"广告分类", path:"/adCategory/index",},
    ]
  },
  {
    title:"用户管理",
    children:[
      {title:"用户列表", path:"/user/index",},
    ]
  },
  {
    title:"系统设置",
    children:[
      {title:"系统设置", path:"/system/index",},
      {title:"管理员列表", path:"/admin/index",},
    ]
  },

]
</script>

<style scoped>
.box{
  margin: 0 5px;
  padding: 10px;
  border-bottom: 1px dashed #e5e3e3;
}
.box-header{}
.box-header .title{
  font-size:15px;
  color: rgba(0,0,0,0.8);
  font-weight: bold;
}
.box-content{
  padding-top: 6px;
}
.box-content .link{
  height: 30px;
  line-height: 30px;
  overflow: hidden;
}
.box-content .link a{
  color: rgba(0,0,0,0.8);
  font-size:14px;
}
.box-content .link a:hover{
  color: #2e83f3;
}
</style>